export const COOKIE_SOURCE = {
    manual: 'manual',
    scanned: 'scanned',
    scanned_now_absent: 'scanned_now_absent',
} as const;
